/**
 * Attendee lists for virtual events (docs/Decisions.md D55). Meeting services
 * export attendee reports as CSV with different column names, so the parser
 * takes every cell that looks like an email address, from any column, and
 * leaves matching to the API (POST /events/{eventId}/attendance), which knows
 * the registered members.
 */

const EMAIL_RE = /^[^\s@,;"<>]+@[^\s@,;"<>]+\.[^\s@,;"<>]+$/;

/** At most this many addresses per upload, as the API enforces. */
export const MAX_ATTENDANCE_EMAILS = 2000;

/**
 * Every distinct email address in a CSV or pasted list, lower-cased, in the
 * order first seen. Cells may be quoted and separated by commas, semicolons,
 * tabs or new lines; a "Name <address>" cell yields the address.
 */
export function parseAttendeeEmails(text) {
  const seen = new Set();
  const out = [];
  for (const raw of String(text || '').split(/[\n\r,;\t]+/)) {
    let cell = raw
      .trim()
      .replace(/^"+|"+$/g, '')
      .trim();
    const angled = cell.match(/<([^>]+)>/);
    if (angled) cell = angled[1].trim();
    const email = cell.toLowerCase();
    if (EMAIL_RE.test(email) && !seen.has(email)) {
      seen.add(email);
      out.push(email);
    }
  }
  return out;
}

/** Whether staff may confirm attendance from a list for this event. */
export function acceptsAttendeeList(event, now = Date.now()) {
  if (!event || !['virtual', 'hybrid'].includes(event.format)) return false;
  return !event.startsAt || new Date(event.startsAt).getTime() <= now;
}
